import { Main, MainBody, MainTop, MainTopTitle } from '@/components/Layout'
import React from 'react'
import { useLocalization } from '@/hooks/localization'
import context from '@/context'
import { ChangeRequest } from './changeRequest'

function ChangeRequestDetail ({ match }) {
  const { localize } = useLocalization()
  const id = Number(match.params.id)
  return (
    <Main path={[{ text: `${id}`, localized: true }]}>
      <MainTop>
        <MainTopTitle>
          {localize('Tasks.ChangeRequest')}
        </MainTopTitle>
      </MainTop>
      <MainBody transparent>
        <ChangeRequest dataSource={() => context.api.changeRequestService.getChangeRequest(id)} />
      </MainBody>
    </Main>
  )
}

export {
  ChangeRequestDetail
}



// WEBPACK FOOTER //
// ./src/report-app/pages/changeRequests/detail.js